export default "__VITE_ASSET__B5JsS0Cu__"